// store/todoList.js
import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API } from '../../constants';
import { application } from '../../services/application';

export const INITIAL_STATE = {
  items: {},
  counts: {
    completed: 0,
    notCompleted: 0,
    notCompletedForms: 0,
  },
  samRegistration: null,
  samFormId: null,
  sap: null,
  sapFormId: null,
  loaded: false,
  pending: true,
  error: null,
};

const getToDoList = createAsyncThunk('todoList/getToDoList', async (params) => {
  return application.call(API.ORGANIZATION.GET_TO_DO_LIST, params);
});

function onGetToDoList(state, action) {
  const payload = action.payload || {};
  const rawItems = payload.result || {};
  const rawCounts = payload.counts || {};

  const samRegistration =
    payload.samRegistration !== undefined && payload.samRegistration !== null ? payload.samRegistration : null;

  const samFormId = payload.samFormId !== undefined && payload.samFormId !== null ? payload.samFormId : null;

  const sap = payload.sap !== undefined && payload.sap !== null ? payload.sap : null;

  const sapFormId = payload.sapFormId !== undefined && payload.sapFormId !== null ? payload.sapFormId : null;

  const completed = Number(rawCounts.completed !== undefined && rawCounts.completed !== null ? rawCounts.completed : 0);

  const notCompleted = Number(
    rawCounts.notCompleted !== undefined && rawCounts.notCompleted !== null ? rawCounts.notCompleted : 0
  );

  const notCompletedForms = Number(
    rawCounts.notCompletedForms !== undefined && rawCounts.notCompletedForms !== null ? rawCounts.notCompletedForms : 0
  );

  state.items = rawItems;
  state.counts = {
    completed,
    notCompleted,
    notCompletedForms,
  };
  state.samRegistration = samRegistration;
  state.samFormId = samFormId;
  state.sap = sap;
  state.sapFormId = sapFormId;
  state.loaded = true;
  state.pending = false;
  state.error = null;
}

const toggleToDoStatus = createAsyncThunk('todoList/toggleToDoStatus', async (params) => {
  return application.call(API.ORGANIZATION.TOGGLE_TO_DO_STATUS, params);
});

function onToggleToDoStatusFulfilled(state, action) {
  const arg = action.meta?.arg || {};
  const targetId = arg.todoId || arg.requestId || arg.id;

  if (!targetId) {
    return;
  }

  const items = state.items || {};
  const keys = Object.keys(items);

  keys.forEach((key) => {
    const item = items[key];
    if (item && item.id === targetId) {
      const currentStatus = item.status;
      let nextStatus = currentStatus;

      if (currentStatus === 'Completed') {
        nextStatus = 'Not Started';
      } else if (currentStatus === 'Not Started') {
        nextStatus = 'Completed';
      }

      items[key] = {
        ...item,
        status: nextStatus,
      };
    }
  });
}

export const actions = {
  getToDoList,
  toggleToDoStatus,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(getToDoList.pending, (state) => {
      state.pending = true;
      state.error = null;
    })
    .addCase(getToDoList.fulfilled, onGetToDoList)
    .addCase(getToDoList.rejected, (state, action) => {
      state.pending = false;
      state.loaded = true;
      state.samRegistration = null;
      state.samFormId = null;
      state.sap = null;
      state.sapFormId = null;
      state.error = action.error?.message || 'Failed to load To-Do list';
    })
    .addCase(toggleToDoStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(toggleToDoStatus.fulfilled, onToggleToDoStatusFulfilled)
    .addCase(toggleToDoStatus.rejected, (state, action) => {
      state.error = action.error?.message || 'Failed to toggle To-Do status';
    });
});
